import {
  DASHBOARD_MESSAGES,
  DAY_IN_MS,
  DEFAULT_PLACEHOLDER,
  DISPLAYCOMPONENT_ACTIONS,
  FILTER_DISPLAY,
  FILTER_KEYS,
  FILTER_TYPES,
  GETINFO,
  ID_LIST,
  SEARCH,
  SECONDARYFILTERS_NAMES,
  TEXT_LABELS
} from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { BarFilter } from "@/modules/Dashboards/AdminDashboard/models/BarFilter";
import { DashboardFilter } from "@/modules/Dashboards/AdminDashboard/models/DashboardFilter";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { RangeField } from "@/modules/Dashboards/AdminDashboard/models/RangeField";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { TreeChildren } from "@/modules/Dashboards/AdminDashboard/models/TreeChilden";
import { Field } from "@/modules/Forms/models/Field";
import { UserService } from "@/modules/User/services/UserService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES, LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import {
  DATE_OPERATORS_OBJ,
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { PreventKey } from "@/shared/mixins/mixins";
import { FullSchema } from "@/shared/models/FullSchema";
import { Utils } from "@/shared/utils/utils";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import FilterCollapse from "./components/FilterCollapse/FilterCollapse.vue";
import FilterTypeAll from "./components/FilterTypeAll/FilterTypeAll.vue";
import SearchOneFilter from "./components/SearchOneFilter/SearchOneFilter.vue";
import {
  EMPTY_OBJ_STRING,
  EVENT_EMITTER,
  FIELD_ROOT,
  FILTER_SEARCH_USER_GENERIC_SEARCH,
  GENERIC_SEARCH_LABELS,
  NAME_FILTER,
  SEARCH_COLLECTION
} from "./constants/GenericSearchConstants";
import { QueryFilter } from "./model/FilterOneItem";
import { AllObjFilterList, FilterData, List, ObjList } from "./model/List";
import { ID_FILTER } from "@/shared/components/GenericSearchBar/constants/GenericSearchConstants";
import { UserStatus } from "@/modules/User/models/UserStatus";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";
import { ConfigSearcher } from "@/shared/models/ConfigSearcher";
import { mapGetters } from "vuex";
import { SELECT_EVENTS } from "@/shared/constants/SelectConstants";
import { MINUTE_IN_MS } from "@/modules/Events/constants/EventConstants";

@Component({
  name: "GenericSearchBar",
  components: { FilterCollapse, FilterTypeAll, SearchOneFilter },
  computed: {
    ...mapGetters({
      callOrigin: "getCallOrigin"
    })
  }
})
export default class GenericSearchBar extends PreventKey {
  @Inject() userService!: UserService;

  @Prop({ default: () => ({ name: "", list: [] }) }) listObj!: ObjList;
  list: List[] = [];
  @Prop({ default: () => "" }) userId!: string;
  @Prop() filterArray!: Filter[];
  @Prop() itemsProp?: TreeChildren[];
  @Prop() schema?: FullSchema[] | Field[];
  @Prop({ default: false }) searchBarIsInDashboard!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: false }) showCloseButton!: boolean;

  LABELS = TEXT_LABELS;
  showFilter = false;
  allSelectFilter: AllObjFilterList = {};

  indexFilter = 0;
  lastFilterUsed: DashboardFilter | {} = {};
  lastFilterUsedRef: DashboardFilter | {} = {};
  ifGenerate = "0";
  userNameSelect = "";
  userIdSelect = "";
  SEARCH_INPUT_TEXT = GENERIC_SEARCH_LABELS.SEARCH_INPUT_TEXT;
  attachRef = "";
  clearFilter = 0;

  USER_SEARCH_CONTEXTUAL_KEY = NAME_FINDERS.USER_SEARCH_CONTEXTUAL;
  SHOW_TOGGLE_ACTIONS = false;
  SHOW_FILTER_USER = false;
  SEARCH_COLLECTION = SEARCH_COLLECTION;
  changingFilter = false;
  callOrigin?: string;

  changeShowFilter() {
    this.showFilter = !this.showFilter;
  }

  deleteFilters() {
    for (const filterSelect in this.allSelectFilter) {
      this.allSelectFilter[filterSelect] = [];
    }
    this.clearFilter = 1 - this.clearFilter;
    this.findItems();
  }

  isMultipleOption(nameFilter: string): boolean {
    return Utils.isMultipleOption(
      nameFilter,
      this.allSelectFilter,
      this.currentFilterSelect.secondaryFilters
    );
  }

  get currentFilterSelect() {
    return this.filterArray[this.indexFilter];
  }

  get filterByDefault() {
    const searchDefault = this.findDefault();
    return (
      this.currentFilterSelect.secondaryFilters.find(
        filter =>
          (searchDefault && searchDefault.defaultFilterId == filter.key) ||
          (!searchDefault && filter.default)
      ) ?? this.currentFilterSelect.secondaryFilters[0]
    );
  }

  findDefault(): ConfigSearcher | undefined {
    const searcher = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE.SEARCHER) ?? "[]"
    ) as ConfigSearcher[];
    return searcher.find(
      search =>
        search.keyRef ==
        this.$vnode.key + "-" + this.currentFilterSelect.mainFilterKey
    );
  }

  validFindItems() {
    this.findItems();
  }

  closeFilter() {
    this.showFilter = false;
  }

  fetchData(keyWord: string) {
    this.$emit(SELECT_EVENTS.EMITTERS.FETCH_DATA, keyWord);
  }

  findItems() {
    if (this.loading) {
      return;
    }

    for (const filter of Object.keys(this.allSelectFilter)) {
      for (const [index, item] of this.allSelectFilter[filter].entries()) {
        if (!item || (item && !item.key)) {
          this.allSelectFilter[filter].splice(index, 1);
        }
        if (this.allSelectFilter[filter].length == 0) {
          delete this.allSelectFilter[filter];
        }
      }
    }

    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    const allSelectFilter: any = {};
    const lastFilterUsed: DashboardFilter | {} = {};
    if (
      this.searchBarIsInDashboard &&
      this.changingFilter &&
      JSON.stringify(this.allSelectFilter) == EMPTY_OBJ_STRING
    ) {
      this.changingFilter = false;
    }
    this.lastFilterUsedRef = JSON.parse(JSON.stringify(this.allSelectFilter));

    if (this.userId) {
      if (this.ifGenerate == "1") {
        allSelectFilter[ID_FILTER.CREATED_BY] = this.userId;
      }
      if (this.userIdSelect) {
        allSelectFilter[ID_FILTER.USER] = this.userIdSelect;
      }
    }

    for (const nameFilter in this.allSelectFilter) {
      const secondaryFilter = this.currentFilterSelect.secondaryFilters.find(
        secundarySelect => secundarySelect.key == nameFilter
      );

      const selectFilter = this.allSelectFilter[nameFilter];

      if (secondaryFilter?.display == FILTER_DISPLAY.DATE) {
        const fecha = [0, 0];
        const TZ = new Date().getTimezoneOffset() * MINUTE_IN_MS;
        if (selectFilter.length == 1) {
          switch (selectFilter[0].operation) {
            case DATE_OPERATORS_OBJ.EQUAL.key:
              fecha[0] = new Date(selectFilter[0].key).getTime() + TZ;
              fecha[1] = fecha[0] + DAY_IN_MS;
              break;
            case DATE_OPERATORS_OBJ.GREATER_THAN_OR_EQUALS.key:
              fecha[0] = new Date(selectFilter[0].key).getTime() + TZ;
              break;
            case DATE_OPERATORS_OBJ.LESS_THAN_OR_EQUALS.key:
              fecha[1] =
                new Date(selectFilter[0].key).getTime() + TZ + DAY_IN_MS;
              break;
          }
        } else if (selectFilter.length == 2) {
          fecha[0] = new Date(selectFilter[0].key).getTime() + TZ;
          fecha[1] = new Date(selectFilter[1].key).getTime() + TZ + DAY_IN_MS;
        }
        if (fecha[0]) {
          allSelectFilter[FILTER_KEYS.DATE_START] = fecha[0];
        }
        if (fecha[1]) {
          allSelectFilter[FILTER_KEYS.DATE_END] = fecha[1];
        }
        if (fecha[0] || fecha[1]) {
          allSelectFilter[FILTER_KEYS.DATE] = secondaryFilter.key;
        }
      } else if (secondaryFilter?.display == FILTER_DISPLAY.RANGE) {
        allSelectFilter[nameFilter] = selectFilter.map(x => x.key);
        allSelectFilter[nameFilter + "Op"] = selectFilter.map(x => x.operation);
      } else if (secondaryFilter?.display == FILTER_DISPLAY.SCHEMA) {
        /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
        const fields: any = {};
        selectFilter.forEach(filter => {
          fields[filter.operation as string] = [filter.key];
        });
        allSelectFilter[FILTER_KEYS.FIELDS] = fields;
      } else if (secondaryFilter?.display == FILTER_DISPLAY.SCHEMA_RANGE) {
        allSelectFilter[FILTER_KEYS.DETAILED_FIELDS] = selectFilter.map(
          filter => ({
            key: filter.key,
            value: filter.operation
          })
        );
      } else {
        if (selectFilter.length >= 1) {
          allSelectFilter[nameFilter] = selectFilter.map(filter => filter.key);
        }
      }
    }

    if (this.searchBarIsInDashboard) {
      Vue.set(lastFilterUsed, FILTER_KEYS.COLLECTION, this.mainFilterKey + "s");
      Vue.set(lastFilterUsed, this.mainFilterKey, allSelectFilter);
      Vue.set(
        lastFilterUsed,
        FILTER_KEYS.DATE_START,
        allSelectFilter[FILTER_KEYS.DATE_START]
      );
      Vue.set(
        lastFilterUsed,
        FILTER_KEYS.DATE_END,
        allSelectFilter[FILTER_KEYS.DATE_END]
      );
      Vue.set(
        lastFilterUsed,
        FILTER_KEYS.DATE,
        allSelectFilter[FILTER_KEYS.DATE]
      );
    } else {
      Object.assign(lastFilterUsed, {
        mainFilterKey: this.mainFilterKey
      });
      Object.assign(lastFilterUsed, allSelectFilter);
    }

    this.lastFilterUsed = lastFilterUsed;
    this.$emit(SEARCH, { ...lastFilterUsed, allSelectFilter });
  }

  get LastFilterUsedArray(): ObjList[] {
    const filterUsedArray: ObjList[] = [];
    if (this.userNameSelect) {
      filterUsedArray.push({
        name: NAME_FILTER.USER,
        list: [{ key: this.userNameSelect, name: this.userNameSelect }]
      });
    }
    for (const filter in this.lastFilterUsedRef) {
      const finterFinder = this.currentFilterSelect.secondaryFilters.find(
        filterSelect => filterSelect.key == filter
      );
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      const filtern = this.lastFilterUsedRef as any;
      if (!finterFinder || filtern[filter].length == 0) {
        continue;
      }
      const obj = {
        name: finterFinder.name,
        list: filtern[filter]
      };
      filterUsedArray.push(obj);
    }

    return filterUsedArray.sort((filterA, filterB) =>
      filterA.name < filterB.name ? -1 : filterA.name > filterB.name ? 1 : 0
    );
  }

  keyboardFilter = "";

  get filterArraySelect() {
    return !this.keyboardFilter
      ? this.filterArray
      : this.filterArray.filter(filter =>
          filter.mainFilterName
            .toLowerCase()
            .startsWith(this.keyboardFilter.toLowerCase())
        );
  }

  clearKeyboardFilter() {
    this.keyboardFilter = "";
  }

  changeFilter(value: Filter) {
    this.items = [FIELD_ROOT];

    this.indexFilter = this.filterArray.findIndex(
      filter => filter.mainFilterKey == value.mainFilterKey
    );
    this.mainFilterValue = value.mainFilterName;
    this.mainFilterKey = value.mainFilterKey;
    this.changingFilter = true;
    this.allSelectFilter = this.searchBarIsInDashboard
      ? {}
      : this.allSelectFilter;
    this.deleteFilters();
    this.findItems();
  }

  itemFilter = {
    ...FILTER_SEARCH_USER_GENERIC_SEARCH,
    getData: this.getUserData
  };

  @Watch("callOrigin")
  watchCallOrigin() {
    return this.callOrigin;
  }

  async getUserData(query: QueryFilter): Promise<UserStatus[]> {
    let listPatient: UserStatus[] = [];
    try {
      let filterQuery = {
        ...query
      };

      if (
        this.callOrigin &&
        this.callOrigin === GENERAL_CONSTANTS.CALL_ORIGIN
      ) {
        filterQuery = {
          ...query,
          callOrigin: this.callOrigin
        };
      }
      const responseData = await this.userService.getUserByFilters(filterQuery);
      if (responseData.code === Http.Found && responseData.data) {
        listPatient = responseData.data.userArray;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
    return listPatient;
  }

  selectItem(item: UserStatus) {
    this.userNameSelect = item.name!;
    this.userIdSelect = item.id;
    this.findItems();
  }

  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  btnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  mainFilterValue = "Seleccionar";
  mainFilterKey = "";
  currentFilter: BarFilter = {
    filterKey: "",
    name: "",
    value: "",
    displayValue: "",
    parentFilter: "",
    operator: ""
  };
  listToShow: List[] = [];

  finalFilter: DashboardFilter | {} = {};
  itemsStorage: { key: string; children: TreeChildren[] }[] = [];
  items: TreeChildren[] = [FIELD_ROOT];

  filterData: FilterData[] = [];

  rangeFieldsList: RangeField[] = [];
  secondaryFilterRef?: SecondaryFilter;
  multipleCount = 0;
  placeholder = "";
  placeholderInital = "";

  async mounted() {
    this.attachRef = "menuFilter-" + this.currentFilterSelect.mainFilterKey;
    this.userIdSelect = this.userId;
    const viewsText = localStorage.getItem(LOCAL_STORAGE.VIEWS) ?? "[]";
    const views = JSON.parse(viewsText) as string[];
    const isAdmin = views.includes(LOCAL_STORAGE.ADMIN_ROLE);
    const isDoctor = views.includes(LOCAL_STORAGE.DOCTOR_PROFILE);

    if (this.userId) {
      if (isAdmin) {
        this.SHOW_FILTER_USER = true;
      }
      if (isDoctor || isAdmin) {
        this.SHOW_TOGGLE_ACTIONS = true;
      }
    }

    this.showFilter = false;
    this.indexFilter = this.filterArray.findIndex(filter => filter.initial);
    this.setMainFilter(this.filterArray[this.indexFilter]);
  }

  get getDefualtSecondaryFilter() {
    return this.filterArray[this.mainFilterIndex].secondaryFilters.find(
      filter => filter.default
    );
  }

  get mainFilterIndex() {
    return this.filterArray.findIndex(
      item => item.mainFilterKey === this.mainFilterKey
    );
  }

  get currentFilterInfo() {
    return {
      name: "",
      key: "",
      avatar: "",
      type: "",
      display: "",
      operators: [""],
      disabled: false,
      options: []
    };
  }
  getSecondaryFilterRef(key: string): SecondaryFilter {
    return this.filterArray[this.mainFilterIndex].secondaryFilters.find(
      filter => filter.key == key
    )!;
  }

  @Watch("listObj")
  setlistObj() {
    const secondaryFilterRef = this.getSecondaryFilterRef(this.listObj.name);
    const list = this.listObj.list;
    this.list = list;
    this.setList(list, secondaryFilterRef);
  }

  setList(list: List[], secondaryFilterRef: SecondaryFilter) {
    if (
      !this.checkIfOnData(secondaryFilterRef, this.getDefualtSecondaryFilter)
    ) {
      this.addFilterData(
        this.mainFilterKey,
        list,
        secondaryFilterRef,
        this.getDefualtSecondaryFilter
      );
    }
    this.updateList(list, secondaryFilterRef);
  }

  updateList(list: List[], secondaryFilterRef: SecondaryFilter) {
    const secondaryFilterKey =
      secondaryFilterRef?.key || this.getDefualtSecondaryFilter?.key;

    const existingData = this.filterData.find(
      data =>
        data.secondaryFilterKey === secondaryFilterKey &&
        (!secondaryFilterRef || data.mainFilterKey === this.mainFilterKey)
    );

    if (existingData) existingData.values = list;

    if (secondaryFilterRef) this.listToShow = list;
  }

  @Watch("itemsProp")
  setItems() {
    this.items[0].children = this.itemsProp;
    this.addItemsProp();
  }

  @Watch("schema")
  setSchema() {
    if (
      this.secondaryFilterRef?.name == SECONDARYFILTERS_NAMES.USER_FIELDS ||
      this.secondaryFilterRef?.key == SECONDARYFILTERS_NAMES.CUSTOM_ORDER_FIELDS
    ) {
      this.buildUserSchema(this.schema as FullSchema[]);
    } else if (
      this.secondaryFilterRef?.key == SECONDARYFILTERS_NAMES.FORM_FIELDS
    ) {
      this.buildSchemaInput(this.schema as Field[]);
    } else if (
      this.secondaryFilterRef?.key == SECONDARYFILTERS_NAMES.FORM_FIELDS_RANGE
    ) {
      this.buildSchemaRangeInput(this.schema as Field[]);
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  handleSearchBarData(data: { type: string; key: string }, parameter?: any) {
    this.$emit(GETINFO, data, parameter);
  }

  closeSearch() {
    this.$emit(EVENT_EMITTER.CLOSE_SEARCH);
  }

  setMainFilter(value: Filter) {
    this.mainFilterValue = value.mainFilterName;
    this.mainFilterKey = value.mainFilterKey;
    this.placeholder = value.placeholder
      ? value.placeholder
      : DEFAULT_PLACEHOLDER;
    this.placeholderInital = this.placeholder;
    this.listToShow = value.secondaryFilters;
    this.secondaryFilterRef = undefined;
    const data = this.getDefualtSecondaryFilter;
    this.multipleCount = 0;
    if (
      data &&
      !this.checkIfOnData(
        this.secondaryFilterRef,
        this.getDefualtSecondaryFilter
      ) &&
      this.filterArray.length > 1
    ) {
      this.handleSearchBarData({ type: this.mainFilterKey, key: data?.key });
    } else if (
      data &&
      !this.checkIfOnData(
        this.secondaryFilterRef,
        this.getDefualtSecondaryFilter
      ) &&
      this.filterArray.length == 1 &&
      this.list.length > 0
    ) {
      this.addFilterData(
        this.mainFilterKey,
        this.list,
        this.secondaryFilterRef,
        this.getDefualtSecondaryFilter
      );
    }

    this.filterArray.forEach(filter => {
      filter.secondaryFilters.forEach(secFilter => {
        secFilter.disabled = false;
      });
    });
    if (this.items[0].children) this.items[0].children.length = 0;
    this.rangeFieldsList.length = 0;
    if (this.searchBarIsInDashboard) {
      this.search();
    }
  }

  search() {
    const partialFilter = {};
    if (this.searchBarIsInDashboard) {
      this.changingFilter = true;
      this.findItems();
      return;
    } else {
      Object.assign(this.finalFilter, partialFilter);
      Object.assign(this.finalFilter, {
        mainFilterKey: this.mainFilterKey
      });
    }
    this.$emit(SEARCH, this.finalFilter);
    this.finalFilter = {};
  }

  addItemsProp() {
    const isOnStorage = this.itemsStorage.find(
      item => item.key == this.secondaryFilterRef?.key
    );
    if (this.secondaryFilterRef && this.items[0].children && !isOnStorage) {
      const items: TreeChildren[] = [];
      this.items[0].children.forEach(val => items.push(Object.assign({}, val)));
      const storedItems = {
        key: this.secondaryFilterRef.key,
        children: items
      };
      this.itemsStorage.push(storedItems);
    }
  }

  checkIfOnData(
    secondaryFilterRef?: SecondaryFilter,
    getDefualtSecondaryFilter?: SecondaryFilter
  ) {
    const secondaryFilterKey = secondaryFilterRef
      ? secondaryFilterRef?.key
      : getDefualtSecondaryFilter?.key;

    const response = this.filterData.find(
      data =>
        data.secondaryFilterKey == (secondaryFilterKey as string) &&
        (!secondaryFilterRef || data.mainFilterKey == this.mainFilterKey)
    );
    if (response) {
      return response;
    }
    return false;
  }

  addFilterData(
    mainFilterKey: string,
    list: List[],
    secondaryFilterRef?: SecondaryFilter,
    getDefualtSecondaryFilter?: SecondaryFilter
  ) {
    const secondaryFilterKey = (secondaryFilterRef
      ? secondaryFilterRef?.key
      : getDefualtSecondaryFilter?.key) as string;

    this.filterData.push({
      mainFilterKey: mainFilterKey,
      secondaryFilterKey: secondaryFilterKey,
      values: list
    });
  }

  async callData(data: SecondaryFilter) {
    this.secondaryFilterRef = data;
    if (
      data.display === FILTER_DISPLAY.SCHEMA ||
      data.display === FILTER_DISPLAY.SCHEMA_RANGE
    ) {
      const listTemplates =
        data.key == SECONDARYFILTERS_NAMES.FORM_FIELDS ||
        data.key == SECONDARYFILTERS_NAMES.FORM_FIELDS_RANGE
          ? FILTER_TYPES.FORM
          : FILTER_TYPES.USER;
      const listForm = this.allSelectFilter[listTemplates]?.map(obj => obj.key);
      await this.handleCustomFieldFilter(listForm);
    } else {
      await this.typeFilters(data);
    }
  }

  editData(data: SecondaryFilter) {
    this.$emit(EVENT_EMITTER.EDIT_AVAILABILITY_NAME, data);
  }

  async typeFilters(data: SecondaryFilter) {
    const typeFilters: {
      [list: string]: {
        [x: string]: () => Promise<void>;
      };
    } = {
      service: {
        serviceTemplate: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        serviceCategory: async () => {
          this.handleSearchBarData(
            { type: this.mainFilterKey, key: data.key },
            ID_LIST.SERVICE_CATEGORY
          );
        },
        servicesCups: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        }
      },
      form: {
        formTemplate: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        }
      },
      user: {
        role: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        dependency: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        userTemplate: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        }
      },
      medicalOrder: {
        orderCups: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        orderState: async () => {
          this.handleSearchBarData(
            { type: this.mainFilterKey, key: data.key },
            ID_LIST.ORDER_STATE
          );
        },
        orderService: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        orderCode: async () => {
          this.handleSearchBarData(
            { type: this.mainFilterKey, key: data.key },
            ID_LIST.ORDER_CODE
          );
        }
      },
      session: {
        sessionTemplates: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        }
      },
      availability: {
        responsable: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        campus: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        space: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        service: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        name: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        }
      },
      documents: {
        category: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        subCategory: async () => {
          this.handleSearchBarData(
            { type: this.mainFilterKey, key: data.key },
            this.allSelectFilter[ID_FILTER.CATEGORY]
          );
        }
      },
      task: {
        formTemplate: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        },
        dependency: async () => {
          this.handleSearchBarData({ type: this.mainFilterKey, key: data.key });
        }
      }
    };

    const typeFilterMain = typeFilters[this.mainFilterKey];
    const typeFilter =
      typeFilterMain !== undefined ? typeFilterMain[data.key] : undefined;
    if (typeFilter !== undefined) {
      await typeFilter();
    }
  }

  async handleCustomFieldFilter(listForm?: string[]) {
    const typesCustomFieldFilter: {
      [x: string]: (() => Promise<void>) | undefined;
    } = {
      form: async () => {
        await this.checkFormTempAndApplyAction(
          DISPLAYCOMPONENT_ACTIONS.SHOWTREEVIEW,
          listForm
        );
      },
      user: async () => {
        await this.checkUserTempAndApplyAction(listForm);
      }
    };
    const typeCustomFieldFilter = typesCustomFieldFilter[this.mainFilterKey];

    if (typeCustomFieldFilter !== undefined) {
      await typeCustomFieldFilter();
    } else {
      const data = this.itemsStorage.find(
        item => item.key == this.secondaryFilterRef?.key
      );
      if (data) {
        const items: TreeChildren[] = [];
        data.children.forEach(item => items.push(Object.assign({}, item)));
        this.items[0].children = items;
        this.items[0].check = true;
      } else {
        this.handleSearchBarData({
          type: this.mainFilterKey,
          key: SECONDARYFILTERS_NAMES.ORDERTEMPLATESCHEMA
        });
      }
    }
  }

  async checkFormTempAndApplyAction(action: string, listForm?: string[]) {
    this.items[0].children = [];

    if (!listForm) {
      Snackbar.popInfo(DASHBOARD_MESSAGES.NO_FORM_TEMPLATE);
    } else {
      const idArray: string[] = listForm ?? [];
      if (
        action === DISPLAYCOMPONENT_ACTIONS.SHOWSCHEMARANGE
          ? this.rangeFieldsList.length === 0
          : ((this.items[0].children as TreeChildren[]).length as number) === 0
      )
        this.handleSearchBarData(
          {
            type: this.mainFilterKey,
            key: SECONDARYFILTERS_NAMES.FORMTEMPLATESCHEMA
          },
          idArray
        );
    }
  }

  async checkUserTempAndApplyAction(listForm?: string[]) {
    this.items[0].children = [];

    if (!listForm) {
      Snackbar.popInfo(DASHBOARD_MESSAGES.NO_FORM_TEMPLATE);
    } else {
      const idArray: string[] = listForm ?? [];

      this.handleSearchBarData(
        { type: this.mainFilterKey, key: SECONDARYFILTERS_NAMES.USERSCHEMA },
        idArray
      );
    }
  }

  buildUserSchema(fullSchema: FullSchema[]) {
    const allOf = fullSchema.slice(1);

    const rangeValues: TreeChildren[] = [];
    const listFields: Array<{
      key: string;
      conversationTitle: string;
      schema: Array<{ title: string; const: string }>;
    }> = [];
    const basicFields: Array<{
      key: string;
      conversationTitle: string;
      schema: string[];
    }> = [];

    allOf.forEach(value => {
      Object.entries(value.properties).forEach(([key, property]) => {
        if (
          property.typeField === "lista" &&
          property["x-display"] !== "checkbox"
        ) {
          if (!listFields.find(item => item.key == key))
            listFields.push({
              conversationTitle: property.title,
              key,
              schema: property.oneOf as Array<{ title: string; const: string }>
            });
        }
        if (
          property.typeField === "basico" &&
          (property.enum?.length as number) > 0 &&
          property["x-display"] !== "checkbox"
        ) {
          if (!basicFields.find(item => item.key == key))
            basicFields.push({
              conversationTitle: property.title,
              key,
              schema: property.enum as string[]
            });
        }
      });
    });

    if (listFields.length === 0 && basicFields.length === 0) {
      Snackbar.popWarning(DASHBOARD_MESSAGES.NO_VALUE_FIELDS);
      return;
    }

    listFields.forEach(listField => {
      rangeValues.push({
        id: listField.key,
        check: true,
        value: "",
        name: listField.conversationTitle,
        list: listField.schema?.map(d => ({
          title: d.title,
          value: d.const
        }))
      });
    });
    basicFields.forEach(basicField => {
      const index = rangeValues.findIndex(field => field.id == basicField.key);
      if (index >= 0) {
        return;
      }
      rangeValues.push({
        id: basicField.key,
        check: true,
        value: "",
        name: basicField.conversationTitle,
        list: basicField.schema?.map(d => ({
          title: d,
          value: d
        }))
      });
    });
    this.items[0].children = rangeValues;
  }

  buildSchemaInput(fields: Field[]) {
    const rangeValues: TreeChildren[] = [];
    const listFields = this.getFormTempListFields(fields);
    const basicFields = this.getFormTempBasicListFields(fields);

    if (listFields.length === 0 && basicFields.length === 0) {
      Snackbar.popWarning(DASHBOARD_MESSAGES.NO_VALUE_FIELDS);
      return;
    }

    listFields.forEach(listField => {
      rangeValues.push({
        id: listField.key,
        check: true,
        value: "",
        name: listField.conversationTitle,
        list: listField.schema[listField.key].oneOf?.map(d => ({
          title: d.title,
          value: d.const
        }))
      });
    });
    basicFields.forEach(basicField => {
      const index = rangeValues.findIndex(field => field.id == basicField.key);
      if (index >= 0) {
        return;
      }
      rangeValues.push({
        id: basicField.key,
        check: true,
        value: "",
        name: basicField.conversationTitle,
        list: basicField.schema[basicField.key].enum?.map(d => ({
          title: d,
          value: d
        }))
      });
    });

    this.items[0].children = rangeValues;
  }

  buildSchemaRangeInput(fields: Field[]) {
    const rangeValues: RangeField[] = [];
    const listFields = this.getFormTempListFields(fields);
    const basicFields = this.getFormTempBasicListFields(fields);
    listFields.forEach(r => {
      const list = r.schema[r.key].oneOf?.map(d => d.score);
      const min = Math.min(...(list as number[]));
      const max = Math.max(...(list as number[]));
      if (this.isValidNumberList(list as number[])) {
        rangeValues.push({
          key: r.key,
          title: r.conversationTitle,
          value: [min, max],
          selected: false,
          list: list as number[]
        });
      }
    });
    basicFields.forEach(r => {
      const list = r.schema[r.key].enum?.map(e => +e);
      const min = Math.min(...(list as number[]));
      const max = Math.max(...(list as number[]));
      if (this.isValidEnumList(r.schema[r.key].enum as string[])) {
        rangeValues.push({
          key: r.key,
          title: r.conversationTitle,
          value: [min, max],
          selected: false,
          list: list as number[]
        });
      }
    });
    if (rangeValues.length === 0) {
      Snackbar.popWarning(DASHBOARD_MESSAGES.NO_RANGE_FIELDS);
      return;
    }

    this.rangeFieldsList = rangeValues;
  }

  getFormTempListFields(fields: Field[]) {
    return fields.filter(
      f => f.type === "lista" && f.visualElement !== "checkbox"
    );
  }

  getFormTempBasicListFields(fields: Field[]) {
    return fields.filter(
      f =>
        f.type === "basico" &&
        (f.schema[f.key].enum?.length as number) > 0 &&
        f.visualElement !== "checkbox"
    );
  }

  isValidEnumList(values: string[]) {
    const isNumericArray = values.reduce((result, value) => {
      return !Number.isNaN(+value) && result;
    }, true);

    if (isNumericArray) {
      const numbersList = values.map(n => +n);
      const min = Math.min(...(numbersList as number[]));
      const max = Math.max(...(numbersList as number[]));
      return min === max && max === 0 ? false : true;
    } else {
      return false;
    }
  }

  isValidNumberList(list: number[]) {
    const min = Math.min(...(list as number[]));
    const max = Math.max(...(list as number[]));
    return min === max && max === 0 ? false : true;
  }

  scrollFunction() {
    Utils.detectScroll(this.$refs, "filterCollapse");
  }

  parseDate(date: Date) {
    const year = date.getFullYear();
    const mount = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${mount <= 9 ? "0" : ""}${mount}-${
      day <= 9 ? "0" : ""
    }${day}`;
  }

  searchFilters() {
    this.findItems();
    this.closeFilter();
  }
}
